import { render, staticRenderFns } from "./fullCalendar.vue?vue&type=template&id=186c8018&scoped=true"
import script from "./fullCalendar.vue?vue&type=script&lang=js"
export * from "./fullCalendar.vue?vue&type=script&lang=js"
import style0 from "./fullCalendar.vue?vue&type=style&index=0&id=186c8018&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186c8018",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/yunxiao/be-3sdnltdmmjqei95chipgpfz5/runner/__flow_work/__flow_builds/182a3969-2a32-4dff-94d8-cf1bbedf203a/workspace/crmeb-mer-admin_BNnv/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('186c8018')) {
      api.createRecord('186c8018', component.options)
    } else {
      api.reload('186c8018', component.options)
    }
    module.hot.accept("./fullCalendar.vue?vue&type=template&id=186c8018&scoped=true", function () {
      api.rerender('186c8018', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/reservation/components/fullCalendar.vue"
export default component.exports